function triggerEdapEvent(trackingContext, text, type) {
    let field = {};
    if (type || type === 'modal') {
        field = {
            action_location: 'in-bottom',
            placement_type: 'modal'
        };
    } else {
        field = {
            action_location: 'above-header',
            placement_type: 'banner'
        };
    }
    trackingContext.trigger(`native_adoption_placement.${text}`, field);
}

export {triggerEdapEvent};
